module.exports = __webpack_public_path__ + "media/images/omniva-new-logo-white-2960c440.svg";